import clsx from 'clsx'
import React, { type FC, useCallback, useId, useState } from 'react'

type Props = {
  value: number
  onChange: (id: string, x: number) => void
}

export const ControlsTimeIndicator: FC<Props> = ({
  value,

  onChange,
}) => {
  const [isDown, setIsDown] = useState<boolean>(false)
  const id = useId()

  const handleDrag = useCallback((e: MouseEvent) => {
    setIsDown(true)
    onChange(id, e.clientX)
  }, [])
  const handleDragEnd = useCallback((e: MouseEvent) => {
    onChange(id, e.clientX)
    setIsDown(false)
  }, [])
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (!isDown) {
        onChange(id, e.clientX)
      }
    },
    [isDown]
  )
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className="flex h-[6px] w-full cursor-pointer rounded-full bg-grey-100 dark:bg-gray-700"
      id={id}
      onClick={handleClick}
      onDragEnd={handleDragEnd}
    >
      <div className="h-1.5 bg-[#00618a]" style={{ width: `${value}%` }} />
      <div
        draggable
        className={clsx(
          'relative left-[-8px] top-[-7px] z-10 flex h-[20px] w-[20px] cursor-grab items-center justify-center rounded-full',
          !isDown && 'p-1'
        )}
        onDrag={handleDrag}
      >
        <span
          className={clsx(
            'flex rounded-full bg-[#004059]',
            isDown ? 'h-[14px] w-[14px]' : 'h-[10px] w-[10px]'
          )}
        />
      </div>
    </div>
  )
}
